export enum DistributionStatus {
    draft = 'DRAFT',
    scheduled = 'SCHEDULED',
    sent = 'SENT',
    failed = 'FAILED',
    pending = 'PENDING'
}
